<template>
	<div class="balance-user" :style="{ '--height': height, }">
		<div class="index-view-top">
			<van-icon @click="toBack" name="arrow-left" size="28" color="#ffffff" />
			<div class="title">{{ $t("head.notice") }}</div>
			<van-icon style="opacity: 0" name="ellipsis" size="28" color="#ffffff" />
		</div>
		<ul class="infinite-list" v-infinite-scroll="load">
			<div class="notice-item" v-for="(item, index) in informationlist" :key="index"
				@click="toNoticeDetails(item)">
				<img src="../assets/gg.png" alt="" />
				<div>
					<div>{{ item.title }}</div>
					<div>{{ item.createTime }}</div>
				</div>
			</div>
		</ul>
	</div>
</template>

<script>
import {
	information
} from "@/utils/request";
export default {
	data() {
		return {
			number: 10,
			current: "1",
			size: "10",
			informationlist: [],
			onPullDown: true, //下拉加载
			height: '',//屏幕高度
		};
	},
	created() {
		let h = document.documentElement.clientHeight || document.body.clientHeight;
		if (h > 0) {
			this.height = h + 'px' //页面高度
		} else {
			this.height = "100vh"
		}
	},
	mounted() {
		this.getInformation();
	},
	methods: {
		getInformation() {
			var that = this;
			information({
				current: that.current,
				size: that.size,
			}).then((res) => {
				if (res.code == "200") {
					that.current = res.data.current
					that.size = res.data.size

					that.informationlist = [...that.informationlist, ...res.data.records];
					let pages = Math.ceil(res.data.total / that.size);
					if (that.current == pages.toString()) {
						that.onPullDown = false
					}
				}
			});
		},
		toNoticeDetails(item) {
			this.$router.push("/noticeDetails?item=" + JSON.stringify(item));
		},
		load() {
			var that = this
			that.current = (parseInt(that.current) + 1).toString()
			if (that.onPullDown == true) {
				that.getInformation()
			}
		},
		toBack() {
			this.$router.go(-1);
		},
	},
};
</script>

<style lang="scss" scoped>
.balance-user {
	width: 100vw;
	height: var(--height);
	background: #0c0b0b;

	.infinite-list {
		height: calc(var(--height) - 3.75rem);
		padding: 0 0.9375rem;
		overflow-y: scroll;
		overflow-x: hidden;
	}

	.notice-item {
		height: 4.8125rem;
		border-bottom: 0.0625rem solid #272727;
		display: flex;
		align-items: center;

		>img {
			display: block;
			height: 2.5rem;
			width: 2.5rem;
			min-width: 2.5rem;
		}

		>div {
			padding-left: 0.625rem;

			>div:nth-child(1) {
				font-size: 0.875rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #ffffff;
				padding-bottom: 0.3125rem;
			}

			>div:nth-child(2) {
				font-size: 0.75rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #999999;
			}
		}
	}

	.index-view-top {
		height: 3.625rem;
		padding: 0 0.9375rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.title {
			font-size: 1.125rem;
			font-family: PingFang SC-Bold, PingFang SC;
			font-weight: bold;
			color: #ffffff;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/notice/notice.vue